import { LicensingPaymentMethodInput, LicensingPaymentMethodRequestInput } from "generatedQueries/processPaymentMethodMutation.graphql";

export function buildLicensingPaymentMethodInput(
    licensingPaymentMethodRequestInput: LicensingPaymentMethodRequestInput | null,
    licensingContractId: number | null,
    animalIds: string[],
    donation: number | null,
    donationNotes: string | null,
    amountToCharge: number): LicensingPaymentMethodInput {

    const paymentMethodRequest: LicensingPaymentMethodRequestInput = licensingPaymentMethodRequestInput ?? {};

    return {
        paymentMethodRequest,
        paymentRequest: {
            acceptedTermsAndConditionsContractId: licensingContractId,
            animalIds,
            donationAmount: donation || 0.0,
            donationNotes: (donation && donationNotes) || null,
            totalAmount: amountToCharge,
        },
    };
}
